// extracted by mini-css-extract-plugin
export default {"starfield":"Starfield_starfield__Ma-sM","star":"Starfield_star__t9ImU","twinkle":"Starfield_twinkle__MLrQf","starDrift":"Starfield_starDrift__djkUs"};